const BASE_URL = process.env.REACT_APP_RBAC_REST_API_URL ?? '';

const ROUTES: Record<string, string> = {
	USER_TENANT_ROLES: `${BASE_URL}/userTenantRoles`,
    CUSTOM_TENANT_ROLES: `${BASE_URL}/tenantRoles/customRoles`,
    USER_ROOT_GROUP: `${BASE_URL}/groups/root-group`
}

export default ROUTES;